import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/icons/expenses-white.svg'


const _hoisted_1 = { class: "flex flex-row items-center justify-between bg-white rounded-2xl shadow p-8" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-row items-center"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center rounded-full bg-primary-dark w-12 h-12" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_4 = {
  key: 0,
  class: "font-semibold ml-4"
}
const _hoisted_5 = { class: "flex flex-col items-center justify-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-500" }, "Title", -1)
const _hoisted_7 = { class: "flex flex-col items-center justify-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-500" }, "Description", -1)
const _hoisted_9 = { class: "capitalize" }
const _hoisted_10 = { class: "flex flex-col items-center justify-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-500" }, "Requested on", -1)
const _hoisted_12 = { class: "flex flex-col items-center justify-center" }
const _hoisted_13 = { class: "text-sm text-gray-500" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Amount (")
const _hoisted_15 = { class: "uppercase" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(") ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DateFormatter = _resolveComponent("DateFormatter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          (_ctx.extraCharge.payroll_period)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.extraCharge.payroll_period.company.visible_name), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("span", null, _toDisplayString(_ctx.extraCharge.title), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.extraCharge.description), 1)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("span", null, [
        _createVNode(_component_DateFormatter, {
          date: _ctx.extraCharge.created_at
        }, null, 8, ["date"])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("span", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.extraCharge.currency), 1),
        _hoisted_16
      ]),
      _createElementVNode("span", null, "$" + _toDisplayString((_ctx.extraCharge.amount / 100).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })), 1)
    ])
  ]))
}